import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class FolderService {
  private newBreadCrumbData = new Subject<any>();
  private removeFolderFile = new Subject<any>();
  constructor(private http: HttpClient) { }

  /*Observalble set for bread crumb component*/
  getCurrentBreadCrumbData() {
    return this.newBreadCrumbData.asObservable();
  }
  setCurrentSelectedFolderIndex(id) {
    this.newBreadCrumbData.next(id)
  }

  createFolder(data: any): Observable<any> {
    console.log("create Folder", data);

    // let body = { title: data }

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "folder", data).subscribe((res: any) => {

        observer.next(res.data.newFolderRes);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  editFolder(data: any): Observable<any> {
    console.log("create Folder", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "folder", data).subscribe((res: any) => {

        observer.next(res.data.newFolderRes);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  deleteFolder(data: any): Observable<any> {
    console.log("create Folder", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.delete(config.baseApiUrl + "folder?_id=" + data).subscribe((res: any) => {

        observer.next(res.data.newFolderRes);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }
  deleteFile(data: any): Observable<any> {
    console.log("Delete file", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.delete(config.baseApiUrl + "folder/files?_id=" + data).subscribe((res: any) => {
        console.log("RES OF FILE DELETE", res);
        this.removeFolderFile.next({ fileId: data })
        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  deleteFolderFiles(): Observable<any> {
    return this.removeFolderFile.asObservable();
  }


  getFolders(): Observable<any> {
    console.log("Getting clients");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder?refModule=documents ").subscribe((res: any) => {
        this.newBreadCrumbData.next(res);
        console.log("Get Folders : ", res);
        observer.next(res.data.folders);
        observer.complete();
      })

    });
  }



  // Get shared documents of labour job for operative user
  getSharedLabourDocumets(folderId: String): Observable<any> {
    return new Observable<any>((observer) => {
      this.http.get(config.baseApiUrl + "folder/labour-documents?refModule=documents" + "&folderId=" + folderId).subscribe((res: any) => {
        // this.newBreadCrumbData.next(res);
        console.log("Get Folders : ", res);
        observer.next(res.data);
        observer.complete();
      })

    });
  }


  getSharedFolders(): Observable<any> {
    // OLD FUNCTION
    // console.log("Getting shared folders");
    // let that = this;
    // return new Observable<any>((observer) => {
    //   console.log("Observable");
    //   this.http.get(config.baseApiUrl + "folder/shared").subscribe((res: any) => {
    //     console.log("Get Folders : ", res);
    //     observer.next(res.data.folders);
    //     observer.complete();
    //   })
    // });

    // NEW FUN WITH SHAREDDOCUMENT MODEL
    console.log("Getting shared folders");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder/shared-doc").subscribe((res: any) => {
        console.log("Get Folders : ", res);
        observer.next(res.data.response);
        observer.complete();
      })
    });
  }

  getSharedFiles(): Observable<any> {
    console.log("Getting shared files");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder/shared-file").subscribe((res: any) => {
        console.log("Get Files :::::::: ", res);
        observer.next(res.data.files);
        observer.complete();
      })
    });
  }

  getFolder(id): Observable<any> {
    console.log("Getting clients");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder?_id=" + id).subscribe((res: any) => {
        console.log("Get Folders : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }


  getFileDetail(id): Observable<any> {
    console.log("Getting File Details");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder/filedetail?_id=" + id).subscribe((res: any) => {
        console.log("Get Folders : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }


  getSharingDetail(id): Observable<any> {
    console.log("Getting File Details");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder/sharing-detail?_id=" + id).subscribe((res: any) => {
        console.log("Get Folders : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }




  getFolderWithSubFolder(id): Observable<any> {
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder/sub?_id=" + id).subscribe((res: any) => {
        console.log("Get Folders In Service====>> : ", res);
        observer.next(res.allFiles);
        observer.complete();
      })
    });
  }

  uploadFileToFolder(data: any): Observable<any> {
    console.log("Adding Files", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "folder/files", data).subscribe((res: any) => {
        console.log("in folder service", res);

        observer.next(res.data.file);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  shareFolder(data: any): Observable<any> {
    console.log("Sharing Folder", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "folder/share", data).subscribe((res: any) => {
        observer.next(res.data.file);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  shareFile(data: any): Observable<any> {
    console.log("Sharing Files", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "folder/share-file", data).subscribe((res: any) => {
        observer.next(res.data.file);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }
  changeFolderParent(data: any): Observable<any> {
    console.log("changeFolderParent", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "folder/change-position", data).subscribe((res: any) => {
        observer.next(res.data.file);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  changeFileParent(data: any): Observable<any> {
    console.log("changeFolderParent", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "folder/dragfile", data).subscribe((res: any) => {
        console.log("IN SERVICE", res)
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  getallFoldersWithFiles(data): Observable<any> {
    console.log("Getting clients");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "folder/getAllFolders", data).subscribe((res: any) => {
        console.log("Get Folders : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  // /**
  //  * folder READ SERVICE
  //  */

  autoReadDocument(data): Observable<any> {
    console.log("Getting clients");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "folder/auto-read", data).subscribe((res: any) => {
        console.log("Marked as read : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });

  }

  markAsRead(data): Observable<any> {
    console.log("Getting clients");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "folder/mark-read", data).subscribe((res: any) => {
        console.log("Marked as read : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }


  markAsReadAdmin(data): Observable<any> {
    console.log("Getting clients");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "folder/mark-read-admin", data).subscribe((res: any) => {
        console.log("Marked as read : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }


  /**
   * 
   * @param id folder or file Id
   * @param type document type: File or Folder
   * @returns Download the report of file or folder
   */
  folderReadReportDownload(id, type): Observable<any> {
    console.log("Getting clients", id, type);
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder/file-share-report?_id=" + JSON.stringify({ 'documentId': id, 'type': type })).subscribe((res: any) => {
        console.log("Marked as read : ", res);
        observer.next(res.data);
      }, err => {
        observer.error(err)
      },
        () => {
          observer.complete();
        })
    });
  }
}
